import ProFeatureLabel from 'components/ProFeatureLabel'
import SurveyLanguageTable from 'components/SurveyLanguageTable'
import { TooltipLabel } from 'components/TooltipLabel'
import React from 'react'
import { Checkbox, Form } from 'semantic-ui-react'

export default function SurveyLanguageSetting({
  isMultilingualSurveyChecked,
  onChangeIsMultilingualSurveyChecked,
  onChangeSurveyLanguage,
  onChangeDefaultSurveyLanguage,
  surveyLanguages,
  enabledMultiligualSurvey,
}) {
  return (
    <Form>
      <Form.Field className="block flex-wrap !flex-col !items-start !mt-4">
        <Form.Group className="items-baseline">
          <Form.Field className="!pr-0">
            <Checkbox
              label="Multilingual surveys"
              checked={isMultilingualSurveyChecked}
              disabled={!enabledMultiligualSurvey}
              onChange={(_, { checked }) => {
                onChangeIsMultilingualSurveyChecked(checked)
              }}
            />
          </Form.Field>
          {!enabledMultiligualSurvey ? (
            <div className="!ml-2">
              <ProFeatureLabel
                title="Multilingual surveys"
                content="Multilingual surveys are available on a higher plan. Upgrade to unlock this feature."
                learnMoreLink="https://help.simplesat.io/en/articles/2696158"
                shouldShowBillingPageLink={true}
              />
            </div>
          ) : (
            <TooltipLabel
              className="tooltip"
              icon={null}
              descriptionTitle="Multilingual surveys"
              descriptionContent={
                <>
                  <p>
                    Support multiple languages in one survey so respondents can answer in their
                    preferred language.
                  </p>
                </>
              }
              learnMoreLink="https://help.simplesat.io/en/articles/2696158"
            />
          )}
        </Form.Group>
      </Form.Field>
      {isMultilingualSurveyChecked && enabledMultiligualSurvey && (
        <SurveyLanguageTable
          surveyLanguages={surveyLanguages}
          onChangeSurveyLanguage={onChangeSurveyLanguage}
          onChangeDefaultSurveyLanguage={onChangeDefaultSurveyLanguage}
        />
      )}
    </Form>
  )
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/SurveyLanguageSetting/index.js